import React from 'react'
import { Link } from 'react-router-dom'

import _map from 'lodash/map'

import { Button, Modal, Message, Icon } from 'semantic-ui-react'

const PoliceReportHistoryLink = ({
  id,
  date_of_incident,
  bin: { serial_number },
}) => (
  <div>
    <Link to={`/app/police-reports/${id}?view=true`} target="_blank">
      Police report for Bin ({serial_number}) on{' '}
      {date_of_incident.substring(0, 10)}
    </Link>
  </div>
)

class PoliceReportsHistory extends React.PureComponent {
  state = { open: false }

  onOpen = () => {
    this.setState({ open: true })
  }

  close = () => this.setState({ open: false })

  render() {
    const { trigger, loading, items } = this.props
    const { open, error } = this.state

    return (
      <Modal
        trigger={trigger}
        dimmer="blurring"
        size="tiny"
        open={open}
        onOpen={this.onOpen}
        onClose={this.close}
      >
        <Modal.Header>Police Reports History</Modal.Header>
        <Modal.Content scrolling>
          {_map(items, item => (
            <PoliceReportHistoryLink key={item.id} {...item} />
          ))}
          {loading && (
            <Message icon>
              <Icon name="circle notched" loading />
              <Message.Content>
                <Message.Header>Just one second</Message.Header>
                We are fetching the history.
              </Message.Content>
            </Message>
          )}
          {error && <Message error header={error} />}
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            icon="checkmark"
            labelPosition="right"
            content="Close"
            onClick={this.close}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default PoliceReportsHistory
